import { useCreateProduct } from './CreateProduct.hooks'
import { ProductCardMolecule } from '../../../components/molecules/ProductCard.molecule'
import {
  CreateInventoryProductOrganism,
  type InventoryAttributes
} from '../../../components/organisms/CreateInventoryProduct.organism'
import { AtlasBodyMain, AtlasBodySubtitle, AtlasListAtom, Filler, Icons, PageContentAtom, PrimaryButtonAtom, StackAtom, ToolbarMolecule } from '@justomx/atlas-components'
import { Product } from 'types/model'
import { TextAreaMolecule } from 'components/molecules/TextArea.molecule'

export const CreateProductPage = () => {
  const {
    actions,
    product,
    origin,
    canConfirm,
    loading,
    description
  } = useCreateProduct()

  const onChange = (attribute: InventoryAttributes, value: string) => {
    switch (attribute) {
      case 'quantity':
      { actions.setQuantity(Number(value)); return }
      case 'lot':
      { actions.setLot(value.trim()); return }
      case 'expiration':
      { actions.setExpiration(value.trim()) }
      case 'description':
      { actions.onchangeDescription(value.trim()); return }
    }
  }

  const tmpProduct: Product = {
    productId: product.productId,
    productName: product.productName,
    productSku: product.productSku,
    productEan: product.productEan,
    productImage: product.productImage as string,
    productZone: product.productZone as string,
    stock: product.stock,
    isWeighable: false
  }

  return <>
    <ToolbarMolecule title='Productos'
                     actionIcon={Icons.ArrowBack}
                     onAction={actions.goBack}/>
    <PageContentAtom>
      <StackAtom gap={32}>
        <ProductCardMolecule product={tmpProduct}/>
        <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
        <AtlasBodySubtitle>Instrucciones</AtlasBodySubtitle>
          <AtlasListAtom style={{listStyleType: 'decimal'}}>
            <li><AtlasBodyMain display="contents">Cuenta el inventario del producto en la ubicación.</AtlasBodyMain></li>
            <li><AtlasBodyMain display="contents">Escribe la información solicitada.</AtlasBodyMain></li>
          </AtlasListAtom>
        </div>
        <CreateInventoryProductOrganism
          description={description}
          onChange={onChange}
        />
      </StackAtom>
      <Filler/>
      <PrimaryButtonAtom
          disabled={loading || canConfirm.disabled }
          onClick={actions.confirm}
      >
        Confirmar
      </PrimaryButtonAtom>
    </PageContentAtom>
  </>
}
